import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCommunityContext } from '@/providers/community-context';
import { AdContentForm } from './components/AdContentForm';
import type { AdContentFormValues } from './components/ad-content-schema';
import axiosInstance from '@/lib/axios';
import { toast } from 'sonner';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle as CardHeaderTitle,
} from '@/components/ui/card';

export default function CreateAdvertisementPage() {
  const navigate = useNavigate();
  const { community } = useCommunityContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (data: AdContentFormValues) => {
    if (!community?.id) return;

    try {
      setIsSubmitting(true);
      const payload = {
        title: data.title,
        notes: data.notes,
        redirectUrl: data.redirectUrl,
      };

      const response = await axiosInstance.post(
        `/api/communities/${community.id}/advertisements`,
        payload
      );

      if (response.data.success) {
        toast.success('Ad created successfully');
        const adId = response.data.advertisementId as string;
        navigate(`/${community.id}/advertisement/ad/${adId}/campaign/new`);
      }
    } catch (error) {
      console.error('Error saving ad:', error);
      toast.error('Failed to create ad');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <Card className="w-full border-0 bg-card shadow-none md:shadow-2xl animate-in slide-in-from-bottom-5 duration-300">
        <CardHeader className="px-3 md:px-6">
          <CardHeaderTitle className="text-2xl font-black tracking-tight text-foreground">
            Create Advertisement
          </CardHeaderTitle>
          <CardDescription className="text-muted-foreground">
            Add the creative content. You&apos;ll set up campaigns after saving.
          </CardDescription>
        </CardHeader>
        <CardContent className="px-3 md:px-6">
          <AdContentForm
            onSubmit={onSubmit}
            isSubmitting={isSubmitting}
            onCancel={() => navigate(-1)}
          />
        </CardContent>
      </Card>
    </div>
  );
}
